import {Injectable, OnDestroy} from '@angular/core';

import {EMPTY, Subject} from 'rxjs';
import {takeUntil, tap, withLatestFrom} from 'rxjs/operators';

import { select, Store } from '@ngrx/store';
import { ofType, createEffect, Actions } from '@ngrx/effects';

import { AppState } from '../core.state';
import { selectRouter } from '../router/router.selector';

import { replaceState, track } from './coreTracking.actions';

import {TrackingMiddleware} from "../../middlewares/tracking/tracking.middleware";
import {Config} from "../../services/config/config.service";

import { successMicrositeSessions } from '../coreAuth/coreAuth.actions';

@Injectable()
export class TrackingEffects implements OnDestroy {
  public isMobile: boolean;
  private readonly destroy$ = new Subject<void>();

  track = createEffect(() => {
    return this.actions$.pipe(
      ofType(track),
      withLatestFrom(this.store.pipe(select(selectRouter))),
      takeUntil(this.destroy$),
      tap(([propVal, routerState]) => {
        this._trackingMiddleware.track(propVal.event);
    }))}, { dispatch: false });

  replaceState = createEffect(() => {
      return this.actions$.pipe(
        ofType(replaceState),
        takeUntil(this.destroy$),
        tap((propVal) => {
          this._trackingMiddleware.setVirtualPageView(propVal.url);
      }))}, { dispatch: false });


  successMicrositeSessionsInitTracking = createEffect(() => {
    return this.actions$.pipe(
      ofType(successMicrositeSessions),
      takeUntil(this.destroy$),
      tap((propVal) => {
        if(propVal.response) {
          this._trackingMiddleware.setUserId(propVal.response.ext_id);
        }
        return EMPTY;
    }))}, { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private _config: Config,
    private _trackingMiddleware: TrackingMiddleware
  ) {
    this.isMobile = this._config.CONFIG.isMobile;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
